import { Injectable } from '@angular/core';
import { Http, Response, Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { HttpClient } from '@angular/common/http';
import { NGXLogger } from 'ngx-logger';

interface ItemsResponse {
    results: string[];
}

@Injectable()
export class AuthServerProvider {
    constructor(
        //private http: Http,
        private http: HttpClient,
        private $localStorage: LocalStorageService,
        private $sessionStorage: SessionStorageService,
        private logger:NGXLogger
    ) { }
id_token:id_tokken;
    getToken() {
        return this.$localStorage.retrieve('authenticationToken') || this.$sessionStorage.retrieve('authenticationToken');
    }

    login(credentials): Observable<any> {
        //this.logger.debug('login called... in AuthServerProvider');
        const data = {
            username:credentials.username,
            password: credentials.password
        };
        return this.http.post('/honcho/api/authenticate', JSON.stringify(data), { observe: 'response' }).map(respone => {
            //console.log('response body is>>>>>',respone.body);
            // const bearerToken = respone.headers.get('Authorization');
            this.id_token=new id_tokken();
            this.id_token=respone.body as id_tokken;
            //this.logger.debug('bearerToken... ' + this.id_token.id_token);
            // if (bearerToken && bearerToken.slice(0, 7) === 'Bearer ') {
            //     const jwt = bearerToken.slice(7, bearerToken.length);
            //     //this.logger.debug('jwt... ' + jwt);
            //     this.storeAuthenticationToken(jwt, credentials);
            //     return jwt;
            // }
            this.storeAuthenticationToken(this.id_token.id_token,credentials);
            return this.id_token.id_token;
        });
        // return this.http.post('api/authenticate', data).map(authenticateSuccess.bind(this));
        // function authenticateSuccess(resp) {
        //     //this.logger.debug('authenticateSuccess called... ' + resp);
        //     const bearerToken = resp.headers.get('Authorization');
        //     //this.logger.debug('bearerToken... ' + resp['id_token']);
        //     if (bearerToken && bearerToken.slice(0, 7) === 'Bearer ') {
        //         const jwt = bearerToken.slice(7, bearerToken.length);
        //         //this.logger.debug('jwt... ' + jwt);
        //         this.storeAuthenticationToken(jwt, credentials.rememberMe);
        //         return jwt;
        //     }
        // }
    }

    loginWithToken(jwt, rememberMe) {
        if (jwt) {
            this.storeAuthenticationToken(jwt, rememberMe);
            return Promise.resolve(jwt);
        } else {
            return Promise.reject('auth-jwt-service Promise reject'); // Put appropriate error message here
        }
    }

    storeAuthenticationToken(jwt, rememberMe) {
        //this.logger.debug('storeAuthenticationToken called...with jwt... ' + jwt);
        //this.logger.debug('storeAuthenticationToken called...with rememberMe... ' + rememberMe);
        // this.$localStorage.clear('authenticationToken');
        // this.$sessionStorage.clear('authenticationToken');
        this.$localStorage.store('authenticationToken', jwt);
        // if (rememberMe) {
        //     this.$localStorage.store('authenticationToken', jwt);
        // } else {
        //     this.$sessionStorage.store('authenticationToken', jwt);
        // }
        //this.logger.debug('storeAuthenticationToken returned...',jwt);
    }

    logout(): Observable<any> {
        return new Observable((observer) => {
            this.$localStorage.clear('authenticationToken');
            this.$sessionStorage.clear('authenticationToken');
            observer.complete();
        });
    }

}
class id_tokken{
    id_token:string;
}



// WEBPACK FOOTER //
// ./src/app/shared/auth/auth-jwt.service.ts